<script>
  import { fade } from "svelte/transition";
  import Img from "../components/Img.svelte";
  import Load from "../components/Load.svelte";
  import OptionAddress from "../components/OptionAddress.svelte";
  import { redirect } from "../pager";
  import Loading from "../components/Loading.svelte";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import format from "number-format.js";
  import Accordion from "../components/accordion/Accordion.svelte";

  //liblary
  import axios from "axios";
  import { session, notif } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  let _token = localStorage.getItem("t");

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let group;

  function addressShow(id) {
    if (document.getElementById("checkout-btn")) {
      if (document.getElementById("checkout-btn").getAttribute("disabled")) {
        document.getElementById("checkout-btn").removeAttribute("disabled");
      }
      if (document.getElementById("checkout-btn").classList != null) {
        document.getElementById("checkout-btn").classList.remove("opacity-25");
      }
    }

    Array.from(document.getElementsByClassName("optionaddress")).forEach(
      (el) => {
        el.style.display = "none";
      }
    );
    // Do stuff here
    if (document.getElementById("optionaddress-" + id)) {
      document.getElementById("optionaddress-" + id).style.display = "block";
    }
    if (document.getElementById("btn-openAlamat")) {
      document.getElementById("btn-openAlamat").style.display = "block";
    }
  }
  function addressUpdate(id) {
    axios
      .post(settings.url + "/sipade/alamat?authorization=" + settings.token, {
        id: id,
        utamakan: true,
      })
      .then(function (response) {
        loadCheckout();
      })
      .catch(function (error) {
        window.location.reload();
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        }
      });
  }
  function choiceAlamat(id) {
    addressUpdate(id);
  }

  function openAlamat() {
    document
      .getElementById("checkout-btn")
      .setAttribute("disabled", "disabled");
    document.getElementById("checkout-btn").classList.add("opacity-25");
    document.getElementById("btn-openAlamat").style.display = "none";
    Array.from(document.getElementsByClassName("optionaddress")).forEach(
      (el) => {
        el.style.display = "block";
      }
    );
  }

  let hargaTotal = 0;
  $: hargaTotal = hargaTotal;
  let itemTotal = 0;
  $: itemTotal = itemTotal;
  let items = [];
  let itemsDisplay = false;

  let noaddress = false;
  function loadCheckout() {
    axios
      .get(settings.url + "/sipade/checkout", {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;
        if (items.alamat) {
          console.log(noaddress);

          group = items.alamat[0].ID;
          if (items.data) {
            items.data.forEach((i) => {
              i.products.forEach((a) => {
                if (a.checked == 1) {
                  hargaTotal =
                    parseInt(hargaTotal) +
                    parseInt(a.quantity) * parseInt(a.details.price);
                }
              });
            });
          }
          if (response.data) {
            noaddress = false;
            setTimeout(() => {
              itemsDisplay = true;

              setTimeout(() => {
                addressShow(group);
              }, 100);
            }, 1000);
          }
        } else {
          noaddress = true;
          console.log(noaddress);
        }
      })
      .catch(function (error) {
        // jika dalam alamat belum di set
        itemsDisplay = false;
        alert = [
          ...alert,
          { message: "Masalah Komunikasi Data", color: "red" },
        ];
      });
  }

  $: if (settings.loggedin == true) {
    loadCheckout();
  }
  let alamat;
  $: alamat = group;

  let require = {
    latlng_pembeli: undefined,
    latlng_penjual: undefined,
    pesanan: undefined,
    ongkir: undefined,
    harga: undefined,
  };

  let loading_indicator = false;
  function handleCheckout(e) {
    loading_indicator = true;

    let el = this;
    let iText = this.innerText;
    el.innerText = "Memproses...";
    el.setAttribute("disabled", "disabled");
    el.classList.add("opacity-25");

    axios
      .post(settings.url + "/sipade/checkout?authorization=" + settings.token)
      .then(function (response) {
        load_notif();
        redirect("/akun/transaksi");
      })
      .catch(function (error) {
        loading_indicator = false;
        el.innerText = iText;
        el.removeAttribute("disabled");
        el.classList.remove("opacity-25");
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        }
      });
  }

  function load_notif() {
    if (_token) {
      axios
        .get(settings.url + "/sipade/notif", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          notif.update((n) => response.data.notif);
        });
    }
  }
</script>

<svelte:head>
  <title>Checkout - Dekatan</title>
</svelte:head>
{#if loading_indicator}
  <Loading />
{/if}
{#if alert.length > 0}
  <div class="fixed bottom-0 mb-10 right-0 z-30 px-2 mx-auto lg:w-auto w-full">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  title="Checkout"
  message={navigation["message"]}
/>
<main
  transition:fade
  class="container lg:pt-24 md:pt-20 pt-24 mx-auto mb-32 lg:px-0 px-1"
>
  {#if noaddress == true}
    <div class="w-full mx-auto px-2">
      <div class="w-full bg-white rounded-lg shadow-lg p-10">
        <div class="my-6 text-center">
          <h2 class="text-3xl">Kamu belum punya alamat pengiriman !</h2>
          <p class="text-gray-500 pb-5">
            Untuk Memulai Belanja, tambahkan informasi alamat tujuan
            pengirimannya dulu ya..
          </p>
          <a
            href="./akun/alamat"
            class="px-10 py-2 rounded-lg bg-blue-400 text-xl text-white"
            >Tambah Alamat</a
          >
        </div>
      </div>
    </div>
  {:else if itemsDisplay}
    <div class="max-w-6xl mx-auto px-3 py-5 bg-white rounded-lg shadow-lg">
      <div class="flex flex-wrap wrap-extended mx-auto">
        <div
          class="w-full lg:w-3/5 lg:border-r md:border-r border-none
            border-gray-400"
        >
          <div class="lg:p-8 p-2 pt-2">
            <div
              class="font-bold border-b-2 py-2 flex justify-between items-center"
            >
              <h2>Alamat Pengiriman</h2>
              <button
                id="btn-openAlamat"
                on:click={openAlamat}
                class="border
                  p-2 py-1 rounded-lg text-sm text-gray-600 focus:bg-gray-500 focus:outline-none"
                ><span>Ubah Alamat</span></button
              >
            </div>
            {#if items.data}
              {#each items.alamat as a}
                <OptionAddress
                  bind:group
                  value={a.ID}
                  on:click={() => choiceAlamat(a.ID)}
                >
                  <div>
                    <div class="text-sm">
                      <b class="receiver-name">{a.nama_penerima}</b>&nbsp;<span
                        class="font-light">({a.label})</span
                      >&nbsp;{#if a.utama == "1"}
                        <span class="bg-blue-200 px-1 rounded text-blue-600"
                          >Utama</span
                        >
                      {/if}
                    </div>
                    <div class="text-sm">{a.telp}</div>
                    <div class="text-sm font-thin">
                      <div class="address">{a.address}</div>
                      <div class="uppercase text-xs">
                        {a.area.desa.jenis}
                        {a.area.desa.nama}
                        {a.area.kec.jenis}
                        {a.area.kec.nama}
                        <br />{a.area.kab.nama}
                        -
                        {a.area.prov.nama}
                      </div>

                      <div class="text-xs text-gray-500">
                        Catatan :
                        {a.catatan}
                      </div>
                    </div>
                  </div>
                </OptionAddress>
              {/each}
            {/if}
          </div>
          {#if items.data}
            {#each items.data as c}
              <div
                class="lg:flex flex-col lg:px-8 px-2 pb-5 border-b-4
                  border-gray-300"
              >
                <div class="my-5 mb-2 flex">
                  <a
                    href="belanja/{c.shop.domain}"
                    class="text-lg font-bold block"
                    ><h2>{c.shop.nameShop}</h2>
                    <span class="text-xs font-normal text-gray-500"
                      >{c.shop.location}</span
                    >
                  </a>
                </div>

                {#each c.products as d}
                  {#if d.checked == 1}
                    <div class="md:table w-full leading-none mb-2">
                      <div
                        class="my-2 lg:flex md:flex block justify-between
                          relative rounded-lg"
                      >
                        <div
                          class="absolute lg:w-20 md:w-20 h-full md:h-auto
                            md:relative align-top rounded rounded-r-none flex"
                        >
                          <picture class="relative p-1">
                            <Img
                              csscont="none"
                              showplaceholder="false"
                              id={d.details.name}
                              css="lg:w-full w-10 rounded-lg"
                              datasrc="https://pics.dekatan.com/{d.pictures
                                .fileName}"
                              alt={d.details.name}
                            />
                          </picture>
                        </div>
                        <div
                          class="pl-8 ml-6 lg:p-3 p-0 pb-0 md:p-0 md:ml-0 w-full
                            align-top"
                        >
                          <div
                            class="relative flex flex-col h-full lg:pt-0 pt-1
                              pr-2"
                          >
                            <a
                              href="product/{d.details.alias}-{d.details.ID}"
                              class="text-sm md:text-base font-bold"
                            >
                              <span class="font-bold"> {d.quantity} </span>
                              x
                              {d.details.name}
                            </a>
                            <div class="mt-2 lg:font-bold font-normal text-sm">
                              <span class="text-orange-500 mr-2">
                                {format("Rp #.###,", d.subtotal)},-
                              </span><br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="text-xs font-thin">
                        {#if d.note != ""}Catatan : {d.note}{/if}
                      </p>
                    </div>
                  {/if}
                {/each}

                <div class="separator my-2" id="sum-{c.shop.domain}">
                  Subtotal
                </div>
                <Accordion
                  css="cursor-pointer"
                  title="<div class='shop-footer__subtotal'><div class='flex justify-between'><div class='sf-row-label subtotal'>Subtotal</div> <div class='sf-row-value subtotal'><span>{format(
                    'Rp #.###,',
                    c.summary.total
                  )}</span></div></div></div>"
                >
                  <div class="clearfix" />
                  <div class="shop-footer">
                    <div>
                      <div class="flex justify-between">
                        <div class="text-sm text-gray-600 font-light">
                          Harga ({c.summary.item}
                          barang)
                        </div>
                        <div class="text-sm text-gray-600 font-normal">
                          {format("Rp #.###,", c.summary.subtotal)}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="text-sm text-gray-600 font-light">
                          Ongkos Kirim
                        </div>
                        <div
                          class="text-sm text-gray-600 font-normal"
                          data-testid="lblSafOngkir-2048686-108435094"
                        >
                          {format("Rp #.###,", c.summary.ship_price)}
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordion>
              </div>
            {/each}
          {/if}
        </div>
        <div class="w-full lg:w-2/5 h-auto p-3 pb-8 md:p-10">
          <div class="lg:sticky" style="top: 100px;">
            <div
              class="border border-gray-400 mt-3 basket-aside rounded-lg
                rounded-b-lg shadow"
            >
              <footer
                class="p-3 border-t rounded-lg bg-blue-100 border-2
                  border-gray-400 transform transition-all duration-300
                  scale-105 hover:scale-110"
              >
                <div class="flex justify-between text-base">
                  <span class="table-cell font-bold w-32">Total Tagihan</span>
                  <span class="table-cell font-bold" id="hargaTotal"
                    >{format("Rp #.###,", items.summary.total)}</span
                  >
                </div>
                <div class="flex justify-between text-green-800 text-sm">
                  <span class="table-cell w-32"
                    >Total Harga ({format("#.###,", items.summary.items)})</span
                  >
                  <span class="table-cell"
                    >{format("Rp #.###,", items.summary.item_total)}</span
                  >
                </div>
                <div class="flex justify-between text-green-800 text-sm">
                  <span class="table-cell w-32">Total Ongkos Kirim</span>
                  <span class="table-cell"
                    >{format("Rp #.###,", items.summary.ship_total)}</span
                  >
                </div>
              </footer>
              <div class="p-3 justify-between flex">
                {#if hargaTotal}
                  <button
                    on:click|preventDefault={handleCheckout}
                    class="text-center rounded-lg w-full mb-2 p-3 mx-1
                      bg-green-500 text-white font-bold transform transition-all
                      duration-300 scale-100 hover:scale-95 focus:outline-none"
                    id="checkout-btn"
                    href="/checkout"
                  >
                    Checkout
                    {#if itemTotal}({itemTotal}){/if}
                  </button>
                {:else}
                  <button
                    on:click|preventDefault={handleCheckout}
                    class="text-center rounded-lg w-full mb-2 p-3 mx-1
                      bg-green-300 text-white font-bold cursor-not-allowed"
                    id="checkout-btn"
                    href="/checkout"
                    on:click|preventDefault
                  >
                    Checkout
                    {#if itemTotal}({itemTotal}){/if}
                  </button>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {:else}
    <Load />
  {/if}
</main>
